export default "<ion-router-outlet></ion-router-outlet>\n  \n<app-main-tab-bar></app-main-tab-bar>";